import clsx from 'clsx';
import parentStyles from '../styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const RadioListItemLoader = () => {
  return /*#__PURE__*/_jsx("li", {
    className: styles.item,
    children: /*#__PURE__*/_jsxs("div", {
      className: clsx(parentStyles.optionsInputLabel, parentStyles['optionsInputLabel--loading']),
      children: [/*#__PURE__*/_jsx("aside", {
        className: parentStyles.optionsInputLabel__aside
      }), /*#__PURE__*/_jsxs("span", {
        className: parentStyles.optionsInputLabel__main,
        children: [/*#__PURE__*/_jsx("h6", {
          className: clsx(parentStyles.optionsInputHeading, parentStyles['optionsInputHeading--loading'])
        }), /*#__PURE__*/_jsx("span", {
          className: clsx(parentStyles.optionsInputSubHeading, parentStyles['optionsInputSubHeading--loading'])
        })]
      })]
    })
  });
};

export default RadioListItemLoader;